import VerifyEmail from './VerifyEmail.vue';

export default VerifyEmail;
